/**
 * Local fork modification, 2026-09-30, MPL-2.0.
 * Capabilities implemented and operated by this self-hosted fork. This is not a vendor license,
 * a paid plan, or permission to use vendor-hosted services. Cloud deployments do not use it.
 */
export const localSelfHostedCapabilities = Object.freeze({
    hideLogtoBranding: true,
    bringYourUi: true,
    // Hardened and verified: local acceptance passes with real IdP, browser, and durable replay ledger.
    idpInitiatedSso: true,
    consoleCollaboration: true,
    // Console administrator MFA policy, not the end-user MFA policy.
    mandatoryMfa: true,
    samlApplicationsLimit: null,
});
/**
 * Local fork modification, 2026-10-12, MPL-2.0.
 *
 * Complete upstream features that this self-hosted build makes available without turning on the
 * global development switch. Keep each entry feature-specific: the global switch also enables
 * diagnostics, Cloud-only work, and vendor integrations that are not local product capabilities.
 */
export const localEnabledFeatures = Object.freeze({
    jwtCustomizerErrorHandling: true,
    ossOnboarding: true,
    resetPasswordMagicLink: true,
    stepUpAuthentication: true,
    tenantManagement: true,
});
/**
 * Resolve an upstream development feature without changing Cloud semantics. Cloud continues to
 * follow its global development flag; self-hosted production may additionally use the reviewed
 * local feature policy above.
 */
export const isFeatureEnabledForEnvironment = (feature, { isCloud, isDevFeaturesEnabled }) => isDevFeaturesEnabled || (!isCloud && localEnabledFeatures[feature]);
